/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_pS as pS,
} from "../../runtime/index.jsx";
export function VincularBot(e) {
  let t = (0, ReactCompiler.c)(6),
    { bot: n } = e,
    r = null;
  if (n.estado === `sin-datos`) r = `Este bot todavía no se puso en marcha.`;
  else if (!n.enLinea) {
    let e;
    (t[0] === n.latidoEn
      ? (e = t[1])
      : ((e = pS(n.latidoEn)), (t[0] = n.latidoEn), (t[1] = e)),
      (r = `El bot no da señales desde ${e}.`));
  } else if (n.desvinculacionPendiente) r = `Preparando un código nuevo…`;
  else if (n.pedidoFallido) {
    let e =
        n.pedidoFallido === `CODIGO`
          ? `No se pudo pedir el código. Prueba de nuevo.`
          : `No se pudo vincular otro teléfono. Prueba de nuevo.`,
      r;
    return (
      t[2] === e
        ? (r = t[3])
        : ((r = (
            <p
              role={`alert`}
              className={`rounded-lg bg-(--error-bg) px-3 py-2 text-xs text-(--error-texto)`}
              children={e}
            />
          )),
          (t[2] = e),
          (t[3] = r)),
      r
    );
  } else
    n.estado === `sesion-cerrada` &&
      (r = `Se cerró la sesión desde el teléfono. Vincula otro teléfono para volver a usarlo.`);
  if (!r) return null;
  let i;
  return (
    t[4] === r
      ? (i = t[5])
      : ((i = <p className={`text-xs text-(--text)`} children={r} />),
        (t[4] = r),
        (t[5] = i)),
    i
  );
}
